export { Skeleton } from "@/shared/ui/shadcn-components/skeleton";
export { CardSkeleton } from "@/shared/ui/loading/CardSkeleton";
export { LoadingCardsGrid } from "@/shared/ui/loading/LoadingCardsGrid";
export {
  SkeletonChatRows,
  SkeletonConfigCard,
  SkeletonPageHeader,
  SkeletonStats,
} from "@/shared/ui/loading/SkeletonPatterns";
